import React from 'react';
import { Alert } from 'reactstrap';
import BoxLogTableRow from './BoxLogTableRow';

const BoxLogTable = ({ boxesList }) => {
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            <th className="cursor-pointer">Event ID</th>
            <th className="cursor-pointer">User</th>
            <th className="cursor-pointer">Event</th>
            <th className="cursor-pointer">Date</th>
            <th className="cursor-pointer">Time</th>
          </tr>
        </thead>
        <tbody>
          {boxesList && boxesList.length ? (
            boxesList.map((box, i) => <BoxLogTableRow box={box} key={i} index={i + 1} />)
          ) : (
            <tr>
              <td colSpan={5}>
                <Alert rowSpan={5} color="info">
                  No Logs Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BoxLogTable;
